var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckbox = function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAB331",
    d: "M1.333 0h21.334c.353 0 .692.141.942.393.25.251.391.592.391.948v21.45c0 .356-.14.697-.39.949a1.33 1.33 0 0 1-.943.392H1.333a1.33 1.33 0 0 1-.942-.392A1.35 1.35 0 0 1 0 22.792V1.34C0 .985.14.644.39.393.64.14.98 0 1.334 0m9.338 17.429 9.426-9.48-1.884-1.896-7.542 7.584-3.772-3.792-1.886 1.895z"
  })));
};
export default SvgCheckbox;